import { render, staticRenderFns } from "./templateSayhiTwo.vue?vue&type=template&id=33ce40d1&scoped=true"
import script from "./templateSayhiTwo.vue?vue&type=script&lang=js"
export * from "./templateSayhiTwo.vue?vue&type=script&lang=js"
import style0 from "./templateSayhiTwo.vue?vue&type=style&index=0&id=33ce40d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce40d1",
  null
  
)

export default component.exports